"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClient = exports.Client = exports.serialize = exports.CLIENT_CACHE = void 0;
const utils_1 = require("@obvio/utils");
const generated_client_1 = require("../constants/generated.client");
const env_1 = require("../env");
const JSON_DATE = '__[object Date]__';
exports.CLIENT_CACHE = '__CLIENT_CACHE__';
function setupArgs(args = {}, enumArgs = []) {
    const names = (0, utils_1.keys)(args);
    if (names.length === 0) {
        return '';
    }
    return `(${names
        .map((name) => {
        var _a;
        const arg = args[name];
        return `${name}:${(enumArgs.includes(name)
            ? Array.isArray(arg)
                ? `[${arg.join(',')}]`
                : arg
            : (_a = JSON.stringify(arg)) === null || _a === void 0 ? void 0 : _a.replace(/"(\w+)":/gu, '$1:')) || 'null'}`;
    })
        .join(',')})`;
}
function setupSelect(under, select = {}) {
    const fieldType = under.type === undefined ? undefined : generated_client_1.SCHEMA_TYPES[under.type];
    if (!fieldType) {
        return '';
    }
    let selectValue = select;
    if (selectValue === true) {
        const primitives = Object.entries(fieldType)
            .filter(([, type]) => !(0, utils_1.has)(generated_client_1.SCHEMA_TYPES, type))
            .map(([fieldName]) => fieldName);
        return `{${primitives.join(' ')}}`;
    }
    const selects = selectValue;
    const selectedFields = (0, utils_1.keys)(selects);
    if (fieldType.id) {
        selectedFields.unshift('id');
        selectValue = Object.assign({ id: true }, selects);
    }
    if (selectedFields.length === 0) {
        throw new Error(`You have to provide selection for field "${under.name}"`);
    }
    return `{${[...new Set(selectedFields)]
        .map((name) => {
        const opt = selects[name];
        return `${name}${setupSelect({ name, type: fieldType === null || fieldType === void 0 ? void 0 : fieldType[name] }, opt)}`;
    })
        .join(' ')}}`;
}
function dateParser(v) {
    if (v === null) {
        return null;
    }
    return new Date(v);
}
const parsers = {
    DateTime: dateParser,
    Date: dateParser,
    Time: dateParser,
};
function getFieldType(_, k, parentType) {
    var _a;
    return typeof k === 'number' ? parentType : (_a = generated_client_1.SCHEMA_TYPES[parentType]) === null || _a === void 0 ? void 0 : _a[k];
}
function isSchemaType(...args) {
    return !!generated_client_1.SCHEMA_TYPES[args[2]];
}
function parseValue(v, _, type) {
    const parser = parsers[type];
    return parser ? parser(v) : v;
}
function serialize(type, name, { args, select } = {}) {
    const enumArgs = (type === 'query' ? generated_client_1.QUERY_ENUM_ARGS : generated_client_1.MUTATION_ENUM_ARGS)[name];
    const returnType = (type === 'query' ? generated_client_1.QUERY_TYPES : generated_client_1.MUTATION_TYPES)[name];
    return args === null
        ? 'not_ready'
        : `${type}{${name}${setupArgs(args, enumArgs)}${setupSelect({
            name,
            type: returnType,
        }, select)}}`;
}
exports.serialize = serialize;
class Client {
    constructor({ cache, server, lang }) {
        this.inFlightQueries = {};
        this.subscribers = {};
        this.query = (name, ...args) => this.sendQuery('query', name, args[0]);
        this.mutate = (name, ...args) => this.sendQuery('mutation', name, args[0]);
        this.cache = (0, utils_1.traverse)((v) => typeof v === 'string' && v.startsWith(JSON_DATE)
            ? new Date(v.replace(JSON_DATE, ''))
            : v, cache !== null && cache !== void 0 ? cache : { __queries: {} });
        this.apollo = server;
        this.lang = lang;
    }
    queryCache(name, options) {
        return this.cache.__queries[serialize('query', name, options)];
    }
    updateCache(newCache) {
        this.cache = {
            __queries: Object.assign(Object.assign({}, (0, utils_1.traverse)((v) => typeof v === 'string' && v.startsWith(JSON_DATE)
                ? new Date(v.replace(JSON_DATE, ''))
                : v, newCache.__queries)), this.cache.__queries),
        };
    }
    setLang(lang) {
        this.lang = lang;
    }
    refetchQueries(...queries) {
        const toRefetch = new Set(queries);
        toRefetch.forEach((qName) => {
            var _a;
            (_a = this.subscribers[qName]) === null || _a === void 0 ? void 0 : _a.forEach((cb) => cb());
        });
    }
    invalidateQueries(...queries) {
        (0, utils_1.keys)(this.cache.__queries).forEach((k) => {
            const [qName] = k.replace('query{', '').split(/\b/u);
            if (queries.includes(qName)) {
                delete this.cache.__queries[k];
            }
        });
        this.refetchQueries(...queries);
    }
    subscribeRefetchQueries(q, callback) {
        var _a;
        if (!this.subscribers[q]) {
            this.subscribers[q] = new Set();
        }
        (_a = this.subscribers[q]) === null || _a === void 0 ? void 0 : _a.add(callback);
        return () => {
            var _a, _b;
            (_a = this.subscribers[q]) === null || _a === void 0 ? void 0 : _a.delete(callback);
            if (((_b = this.subscribers[q]) === null || _b === void 0 ? void 0 : _b.size) === 0) {
                delete this.subscribers[q];
            }
        };
    }
    ssrData(pageProps) {
        return {
            props: (0, utils_1.traverse)(this.serializeDate, Object.assign(Object.assign({}, pageProps), { [exports.CLIENT_CACHE]: this.cache })),
        };
    }
    serializeDate(v) {
        return (v instanceof Date ? `${JSON_DATE}${v.toISOString()}` : v);
    }
    sendQuery(type, name, _a = {}) {
        var { merge = (prev, next) => Array.isArray(prev) && Array.isArray(next)
            ? [...prev, ...next]
            : Array.isArray(prev === null || prev === void 0 ? void 0 : prev.data)
                ? Object.assign(Object.assign({}, next), { data: [...prev.data, ...next.data] }) : next, fetchMoreArgs } = _a, options = __rest(_a, ["merge", "fetchMoreArgs"]);
        return __awaiter(this, void 0, void 0, function* () {
            const { fetchPolicy, args, clearCache, refetchQueries } = options;
            const fromCache = type === 'query' && fetchPolicy !== 'networkOnly' && !fetchMoreArgs
                ? this.queryCache(name, options)
                : undefined;
            if (fromCache) {
                return fromCache;
            }
            const serializedRequest = serialize(type, name, options);
            const getRequestResult = () => __awaiter(this, void 0, void 0, function* () {
                let res;
                if (this.apollo) {
                    res = yield this.apollo.executeOperation({ query: serializedRequest });
                }
                else {
                    const requestData = yield fetch(`${(0, env_1.getHomeUrl)()}/api`, {
                        method: 'POST',
                        credentials: 'same-origin',
                        headers: (0, utils_1.exclude)({
                            'Content-Type': 'application/json',
                            'Accept-Language': this.lang,
                        }, undefined),
                        body: JSON.stringify({
                            query: fetchMoreArgs
                                ? serialize(type, name, Object.assign(Object.assign({}, options), { args: Object.assign(Object.assign({}, args), fetchMoreArgs) }))
                                : serializedRequest,
                        }),
                    });
                    res = yield requestData.json();
                }
                const error = res.errors;
                if (error) {
                    delete this.inFlightQueries[serializedRequest];
                    throw new utils_1.CustomError(res.errors);
                }
                else if (res.data) {
                    let data = res.data[name];
                    const returnType = (type === 'query' ? generated_client_1.QUERY_TYPES : generated_client_1.MUTATION_TYPES)[name];
                    if (returnType && data) {
                        data = (0, utils_1.isTraversable)(data)
                            ? (0, utils_1.traverse)(parseValue, data, isSchemaType, returnType, getFieldType)
                            : parseValue(data, null, returnType);
                    }
                    const result = fetchMoreArgs
                        ? merge(this.cache.__queries[serializedRequest], data)
                        : data;
                    if (type === 'query') {
                        this.cache.__queries[serializedRequest] = result;
                    }
                    else if (clearCache) {
                        this.cache.__queries = {};
                        (0, utils_1.values)(this.subscribers).forEach((callbacks) => callbacks.forEach((cb) => cb()));
                    }
                    else if (refetchQueries) {
                        this.invalidateQueries(...refetchQueries);
                    }
                    return result;
                }
                else {
                    throw new Error('Something went wrong');
                }
            });
            if (!(serializedRequest in this.inFlightQueries)) {
                this.inFlightQueries[serializedRequest] = getRequestResult();
            }
            const resolvedRequest = yield this.inFlightQueries[serializedRequest];
            delete this.inFlightQueries[serializedRequest];
            return resolvedRequest;
        });
    }
}
exports.Client = Client;
let client;
function createClient(clientArguments = {}) {
    if (client) {
        if (clientArguments.cache) {
            client.updateCache(clientArguments.cache);
        }
        if (clientArguments.lang) {
            client.setLang(clientArguments.lang);
        }
        return client;
    }
    const newClient = new Client(clientArguments);
    if (!env_1.IS_SERVER) {
        client = newClient;
    }
    if (process.env.NODE_ENV === 'development') {
        ;
        global.__client__ = client;
    }
    return newClient;
}
exports.createClient = createClient;
